module.exports = __webpack_public_path__ + "static/media/Instagram.d1b891e6.svg";